import { render, staticRenderFns } from "./lessonView.vue?vue&type=template&id=12c077bc&"
import script from "./lessonView.vue?vue&type=script&lang=js&"
export * from "./lessonView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports